<template id="">
  <v-footer class="pa-3" style="z-index:20; background-color:transparent">
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }} Oxford Pers&#xF6;nlichkeitstest |&nbsp;</div>
	   <router-link :to="{ name: 'about'}" target="_blank">
      Datenschutzerkl&#xE4;rung
    </router-link>&nbsp;|&nbsp;<router-link :to="{ name: 'impressum'}" target="_blank">Impressum</router-link>
    <v-spacer></v-spacer>
    <br>
    <cookie-law theme="dark-lime" style="opacity:0.9" buttonText="Akzeptieren">
      <div slot="message">
        Die Webseite verwendet Cookies. Cookies helfen uns bei der Bereitstellung unserer Dienste. Durch die Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies setzen.
        <router-link :to="{ name: 'about'}" target="_blank">Mehr erfahren</router-link>
      </div>
    </cookie-law>
  </v-footer>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'
  export default {
    components: { CookieLaw }
  }
</script>
